import React from 'react';
import styled from 'styled-components';
import { Text03 } from 'components/styles';

export const EmptyContent = styled.span`
  ${Text03};
`;

export const EmptyCell = () => <EmptyContent>—</EmptyContent>;
